export * from '@fhs/routing/src/routes/v2/index';
export { default } from '@fhs/routing/src/routes/v2/index';
